export const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    // Check if the script already exists
    const existingScript = document.getElementById('forward-payment-sdk-script');
    if (existingScript) {
      // Check if the script has already loaded successfully
      if (existingScript.readyState === 'complete' || existingScript.readyState === 'loaded') {
        resolve({ loaded: true, error: false });
        return;
      }
      // If script exists but hasn't loaded yet, wait for it
      existingScript.onload = () => {
        resolve({ loaded: true, error: false });
      };
      existingScript.onerror = (error) => {
        console.error('Existing script loading error:', error);
        reject({ loaded: false, error: true, message: `Failed to load script: ${src}` });
      };
      return;
    }

    const script = document.createElement('script');
    script.id = 'forward-payment-sdk-script';
    script.src = src;
    script.async = true;
    script.type = 'text/javascript';
    
    // Add crossorigin attribute to handle CORS issues with ngrok
    script.crossOrigin = 'anonymous';
    
    // Add referrerPolicy to help with ngrok tunneling
    script.referrerPolicy = 'no-referrer-when-downgrade';

    // Add timeout for script loading to handle ngrok timeouts
    const timeout = setTimeout(() => {
      console.error('Script loading timeout:', src);
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      reject({ 
        loaded: false, 
        error: true, 
        message: `Script loading timeout: ${src}` 
      });
    }, 30000); // 30 second timeout

    script.onload = () => {
      clearTimeout(timeout);
      console.log('Script loaded successfully:', src);
      resolve({ loaded: true, error: false });
    };

    script.onerror = (error) => {
      clearTimeout(timeout);
      console.error('Script loading error:', error);
      console.error('Failed to load script from:', src);
      
      // Remove the failed script element
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      
      reject({ 
        loaded: false, 
        error: true, 
        message: `Failed to load script: ${src}. This might be due to CORS issues or network connectivity.` 
      });
    };

    try {
      document.head.appendChild(script);
    } catch (error) {
      clearTimeout(timeout);
      console.error('Error appending script to head:', error);
      reject({ 
        loaded: false, 
        error: true, 
        message: `Failed to append script: ${src}` 
      });
    }
  });
};
